import {
  TableHeader as AriaTableHeader,
  Collection,
  TableHeaderProps,
} from "react-aria-components";

export function DataTableHeader<T extends object>({
  columns,
  children,
  ...otherProps
}: TableHeaderProps<T>) {
  return (
    <AriaTableHeader {...otherProps}>
      <Collection items={columns}>{children}</Collection>
    </AriaTableHeader>
  );
}
